import translationam from './translation-am.json';
import translationar from './translation-ar.json';
import translationbn from './translation-bn.json';
import translationcs from './translation-cs.json';
import translationde from './translation-de.json';
import translationen from './translation-en.json';
import translationes from './translation-es.json';
import translationfa from './translation-fa.json';
import translationfil from './translation-fil.json';
import translationfr from './translation-fr.json';
import translationgu from './translation-gu.json';
import translationhi from './translation-hi.json';
import translationht from './translation-ht.json';
import translationid from './translation-id.json';
import translationit from './translation-it.json';
import translationja from './translation-ja.json';
import translationko from './translation-ko.json';
import translationne from './translation-ne.json';
import translationnl from './translation-nl.json';
import translationpa from './translation-pa.json';
import translationpl from './translation-pl.json';
import translationpt from './translation-pt.json';
import translationro from './translation-ro.json';
import translationru from './translation-ru.json';
import translationrw from './translation-rw.json';
import translationsk from './translation-sk.json';
import translationso from './translation-so.json';
import translationsw from './translation-sw.json';
import translationta from './translation-ta.json';
import translationte from './translation-te.json';
import translationti from './translation-ti.json';
import translationtr from './translation-tr.json';
import translationuk from './translation-uk.json';
import translationur from './translation-ur.json';
import translationvi from './translation-vi.json';
import translationzh from './translation-zh.json';
import translation from './translation.json';

// webpack transforms these JSON imports to resource URLs, so we cast our export accordingly here.
const i18nEndPointMap: Record<string, string> = {
  'translation-am.json': translationam as unknown as string,
  'translation-ar.json': translationar as unknown as string,
  'translation-bn.json': translationbn as unknown as string,
  'translation-cs.json': translationcs as unknown as string,
  'translation-de.json': translationde as unknown as string,
  'translation-en.json': translationen as unknown as string,
  'translation-es.json': translationes as unknown as string,
  'translation-fa.json': translationfa as unknown as string,
  'translation-fil.json': translationfil as unknown as string,
  'translation-fr.json': translationfr as unknown as string,
  'translation-gu.json': translationgu as unknown as string,
  'translation-hi.json': translationhi as unknown as string,
  'translation-ht.json': translationht as unknown as string,
  'translation-id.json': translationid as unknown as string,
  'translation-it.json': translationit as unknown as string,
  'translation-ja.json': translationja as unknown as string,
  'translation-ko.json': translationko as unknown as string,
  'translation-ne.json': translationne as unknown as string,
  'translation-nl.json': translationnl as unknown as string,
  'translation-pa.json': translationpa as unknown as string,
  'translation-pl.json': translationpl as unknown as string,
  'translation-pt.json': translationpt as unknown as string,
  'translation-ro.json': translationro as unknown as string,
  'translation-ru.json': translationru as unknown as string,
  'translation-rw.json': translationrw as unknown as string,
  'translation-sk.json': translationsk as unknown as string,
  'translation-so.json': translationso as unknown as string,
  'translation-sw.json': translationsw as unknown as string,
  'translation-ta.json': translationta as unknown as string,
  'translation-te.json': translationte as unknown as string,
  'translation-ti.json': translationti as unknown as string,
  'translation-tr.json': translationtr as unknown as string,
  'translation-uk.json': translationuk as unknown as string,
  'translation-ur.json': translationur as unknown as string,
  'translation-vi.json': translationvi as unknown as string,
  'translation-zh.json': translationzh as unknown as string,
  'translation.json': translation as unknown as string
}

export default i18nEndPointMap;
